import { initializePDFViewer } from './inc/cco-pdf-viewer.js'

const pageReady = () => {
  initializePDFViewer()
}

if (
  document.readyState === 'complete'
  || (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
  pageReady()
} else {
  document.addEventListener('DOMContentLoaded', pageReady)
}
